<!-- Main Layout Container with Light Gray Background -->
<div class="h-screen overflow-hidden bg-sidebar">
  <!-- Sidebar at background level -->
  <app-docs-sidebar></app-docs-sidebar>

  <!-- Main Content Card Overlay -->
  <div class="absolute inset-0 flex">
    <!-- Spacer for sidebar width -->
    <div
      [style.width.px]="sidebarService.width()"
      class="shrink-0 transition-all duration-300 ease-in-out sidebar-spacer"
    ></div>

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col min-w-0 min-h-0 px-2 sm:px-4">
      <!-- Main Content Card -->
      <main class="flex-1">
        <div
          hlmCard
          class="overflow-hidden flex flex-col my-2 !py-0 !gap-0 h-[calc(100vh-1rem)]"
        >
          <!-- Card Header with Toggle Button -->
          <div hlmCardHeader class="ks-page-scroll !block overflow-y-auto border-b border-border !px-0 py-4">
            <div class="ks-page-container flex items-center col-start-1 row-span-2 row-start-1">
              <button
                hlmBtn
                (click)="toggleSidebar()"
                aria-label="Sidebar umschalten"
                class="rounded-md p-2 mr-1 flex items-center justify-center transition-colors justify-self-start"

                variant="ghost"
                size="sm"
              >
                <ng-icon
                  name="lucidePanelLeft"
                  class="w-4 h-4 text-muted-foreground"
                ></ng-icon>
              </button>
              <brn-separator
                decorative
                hlmSeparator
                orientation="vertical"
                class="h-6 mr-3"
              ></brn-separator>
              <h3 hlmLead>
                {{ pageTitle() }}
              </h3>
            </div>
          </div>

          <!-- Main Content -->
          <div hlmCardContent class="ks-page-scroll flex-1 overflow-y-auto !px-0">
            <!-- Router Outlet for Dynamic Content -->
            <div class="ks-page-container py-5">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</div>
